import { useEffect } from 'react';

import Routes from './routes/Routes';
import appTheme from './theme/AppTheme';
import WithTheme from './theme/WithTheme';

function App() {
  useEffect(() => {
    const updateFavicon = () => {
      const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const lightFavicon = document.getElementById('favicon-light');
      const darkFavicon = document.getElementById('favicon-dark');

      if (darkMode) {
        darkFavicon?.setAttribute('rel', 'icon');
        lightFavicon?.setAttribute('rel', 'alternate-icon');
      } else {
        lightFavicon?.setAttribute('rel', 'icon');
        darkFavicon?.setAttribute('rel', 'alternate-icon');
      }
    };

    updateFavicon();

    const mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
    const listener = (e: MediaQueryListEvent) => {
      updateFavicon();
    };

    mediaQueryList.addEventListener('change', listener);

    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, []);

  return (
    <div className='App'>
      <Routes />
    </div>
  );
}

export default WithTheme(appTheme, App, true);
